import userInfo from "../../function/userInfo";
import i18n from "../../locales/i18n";
import * as API from "../ApiConfig";

export default {
  DoGetPackageDetail() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Package/GetPackageDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoGetSubscriptionHistoryTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      isUseMainDatabase: input.isUseMainDatabase,
      subscriptionHistoryRequest: {
        fromDate: input.fromDate,
        toDate: input.toDate,
        subscriptionHistoryTableView: input.subscriptionHistoryTableView,
        tableSorting: input.tableSorting,
        pageNo: input.pageNo,
        pageSize: input.pageSize,
        statusId: input.statusId,
        searchText: input.searchText,
      },
    };
    return API.peakAPI
      .post("/api/Table/GetSubscriptionHistoryTable", _input,userInfo.SetHeaderService() )
      .then((res) => {
        return res;
      })    
  },
  DoAttachFileWhtPuunReceipt(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      puunWhtReceipt: {
        receiptId: input.receiptId,
        receiptNumber: input.receiptNumber,
        whtNumber: input.whtNumber,
        whtDate: input.whtDate,
        file: input.file,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Package/AttachFileWhtPuunReceipt", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoGetPromoCodeDetail(promoCode) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      promoCode: promoCode.value,
    };
    return API.peakRealTimeAPI
      .post("/api/Package/GetPromoCodeDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoGetPackageRecurring() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Package/GetPackageRecurring", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoGetPackageScbQrCode(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      upgradePackage: input.upgradePackage,
      upgradePayment: input.upgradePayment,
    };
    return API.peakRealTimeAPI
      .post("/api/Package/GetPackageScbQrCode", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoGetPackageScbQrCodePayment(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      data: {
        language: i18n.locale,
        upgradePackageModel: input.upgradePackage,
        upgradePaymentModel: input.upgradePayment,
      },
    };
    return API.peakAppConnect
      .post("/api/SCB/GetPackageScbQrCode", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoGetQrCodeDataModelFromMongo(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      billPaymentRef1: input.billPaymentRef1,
      billPaymentRef2: input.billPaymentRef2,
      billPaymentRef3: input.billPaymentRef3,
    };
    return API.peakRealTimeAPI
      .post("/api/Merchant/GetSCBQRCodeDataModelFromMongo", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoUpgradePackageScbQr(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      upgradePackage: input.upgradePackage,
      upgradePayment: input.upgradePayment,
      scbQr: input.scbQr,
    };
    return API.peakRealTimeAPI
      .post("/api/Package/UpgradePackageScbQr", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoUpgradeToPackage(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      upgradeToPackageData: input,
    };
    return API.peakRealTimeAPI
      .post("/api/Package/UpgradeToPackage", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoUpgradePackageBankTransfer(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      upgradePackage: input.upgradePackage,
      upgradePayment: input.upgradePayment,
      puunContact: input.puunContact,
      file: input.file,
      bankReference: input.bankReference,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/Package/UpgradePackageBankTranfer", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoUpgradePackageOmise(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      upgradePackage: input.upgradePackage,
      upgradePayment: input.upgradePayment,
      puunContact: input.puunContact,
      cardCharge: input.cardCharge,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/Package/UpgradePackageOmise", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoUpgradeRecurringOmise(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      upgradePackage: input.upgradePackage,
      upgradePayment: input.upgradePayment,
      puunContact: input.puunContact,
      cardCharge: input.cardCharge,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/Package/UpgradeRecurringOmise", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoDeletePackageRecurring(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      reason: input,
    };
    return API.peakRealTimeAPI
      .post("/api/Package/DeletePackageRecurring", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoOmiseAddCard(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      cardAttach: input,
    };
    return API.peakRealTimeAPI
      .post("/api/Package/OmiseAddCard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoOmiseGetCardList() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakRealTimeAPI
      .post("/api/Package/OmiseGetCardList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoOmiseRemoveCard(cardToken) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      cardRemove: {
        cardToken: cardToken,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Package/OmiseRemoveCard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoOmiseDefaultCard(cardToken) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      cardAttach: {
        cardToken: cardToken,
      },
    };
    return API.peakRealTimeAPI
      .post("/api/Package/OmiseDefaultCard", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  DoGetAttachmentWhtReceiptPuunFile(input) {
    let _input = {
      puunMerchantId: input.puunMerchantId,
      puunReceiptId: input.puunReceiptId,
    };
    return API.peakRealTimeAPI
      .post("/api/File/GetAttachmentWhtReceiptPuunFile", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
};
